import { makeAutoObservable, runInAction } from 'mobx'
import Radom, { PooledEurOnrampInstructions } from './Radom'

/**
 * Org-gated availability of the pooled fiat rails (cash deposits and cash
 * withdrawals on the funding page). Served by the API from the
 * FIAT_RAMPS_ORG_ALLOWLIST system setting, so rollout is controlled without a
 * frontend deploy. Defaults to disabled until loaded.
 */
class FiatRamps {
  loaded: boolean = false
  cashDepositEnabled: boolean = false
  cashWithdrawalEnabled: boolean = false
  pooledEur?: PooledEurOnrampInstructions

  constructor() {
    makeAutoObservable(this)
    void this.load()
  }

  load = async (): Promise<void> => {
    try {
      const instructions = await Radom.getPooledEurOnrampInstructions()
      runInAction(() => {
        this.pooledEur = instructions
        this.cashDepositEnabled = !!instructions.cashDepositEnabled
        this.cashWithdrawalEnabled = !!instructions.cashWithdrawalEnabled
        this.loaded = true
      })
    } catch {
      runInAction(() => {
        this.pooledEur = undefined
        this.cashDepositEnabled = false
        this.cashWithdrawalEnabled = false
        this.loaded = true
      })
    }
  }
}

export default new FiatRamps()
